import React from 'react';
import ReactModal from 'react-modal';
import Styles from './ClubRegistrationSlideOutModal.module.scss';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, .7)',
    zIndex: '16777216',
  },
};

const classObject = {
  base: Styles.base,
  afterOpen: Styles.afterOpen,
  beforeClose: Styles.beforeClose,
};

const BottomSlideupModal = (props) => {
  const { isOpen, toggleModal } = props;

  ReactModal.setAppElement(document.getElementsByTagName('BODY')[0]);

  return (
    <ReactModal
      className={classObject}
      isOpen={isOpen}
      closeTimeoutMS={450}
      style={customStyles}
      shouldCloseOnOverlayClick={true}
      onRequestClose={toggleModal}
      htmlOpenClassName={'ReactModal__Html--open'}
      parentSelector={() => document.getElementsByTagName('PingNationClubRegistrationWidget')[0]
      }
    >
      {props.children}
    </ReactModal>
  );
};

export default BottomSlideupModal;
